module.exports = __webpack_public_path__ + "img/btn_order.11e62297.svg";